import { render, staticRenderFns } from "./ChatPage.vue?vue&type=template&id=763f7b0a&scoped=true&"
import script from "./ChatPage.vue?vue&type=script&lang=js&"
export * from "./ChatPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f7b0a",
  null
  
)

export default component.exports